module.exports = __webpack_public_path__ + "img/img_video_single.d1195fa9.png";